import type { LocationQuery } from 'vue-router';

/** The in-app path to return to after sign-in, or null; never an external or protocol-relative URL. */
export function redirectTarget(query: LocationQuery): string | null {
  const raw = Array.isArray(query.redirect) ? query.redirect[0] : query.redirect;
  if (
    typeof raw !== 'string' ||
    !raw.startsWith('/') ||
    raw.startsWith('//') ||
    raw.includes('\\')
  ) {
    return null;
  }
  return raw;
}

export function isInvitationRedirect(query: LocationQuery): boolean {
  return redirectTarget(query)?.startsWith('/invitations/accept') ?? false;
}
